export default __webpack_public_path__ + "static/product8-59d5182e6f04750305cc4c64363d3d52.png";